import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Tabs } from 'antd';
import qs from 'qs';
import { getSessionObject, Utils } from '@/tools/utils'
import LoginPassword from './login-password';
import LoginPhone from './login-phone';
import LoginSwitch from './login-switch';
import FooterLoginMethod, {loginMethod} from './footer-login-method';

const { TabPane } = Tabs;

const CommonLogin = (props) => {
    const location = useLocation();
    const history = useHistory();
    const search = location.search
    const merchantBelong = new URLSearchParams(search).get('merchantBelong');
    const query = merchantBelong ? `?merchantBelong=${merchantBelong}` : ''

    const qsStr = location.search.replace('?', '');
    const qsObj = qs.parse(qsStr);
    const [loginType, setLoginType] = useState(qsObj.loginType || '');

    useEffect(() => {
        const qsStr = location.search.replace('?', '');
        const qsObj = qs.parse(qsStr);
        setLoginType(qsObj.loginType || 'password');
    }, [loginType, location]);

    // 存在loginData则说明已经登录，需要进行选择商户或者统一密码
    useEffect(() => {
        const loginData = getSessionObject('loginData') || {};
        if (loginData.needUnifiedPwd) {
            history.push('/login/unify' + query);
            return;
        }
        // 判断是否存在多个关联商户，需要选择所登录的商户
        if (loginData.merchants && loginData.merchants.total > 1) {
            history.push('/login/select' + query);
            return;
        }
        Utils.customTrack('MerchantLogin');
    }, []);

    const changeLabel = (activeKey) => {
        history.push(`/login?loginType=${activeKey}${merchantBelong ? '&merchantBelong=' + merchantBelong : ''}`);
        // Utils.customTrack('MerchantLoginClick', {
        //     element_content: activeKey === 'password' ? '密码登录' : '验证码登陆'
        // });
    };

    return (
        <div>
            <div style={{padding: '10px 56px 0px 20px', margin: '26px 0 48px'}}>
                <Tabs defaultActiveKey={loginType} onChange={changeLabel} centered>
                    <TabPane tab='密码登录' key='password'>
                        <LoginPassword></LoginPassword>
                    </TabPane>
                    <TabPane tab='验证码登录' key='phone'>
                        <LoginPhone></LoginPhone>
                    </TabPane>
                </Tabs>
                <LoginSwitch></LoginSwitch>
            </div>
            <FooterLoginMethod type={loginMethod.微信扫码登录} />
        </div>
    );
};
export default CommonLogin;
